document.addEventListener('DOMContentLoaded', () => {
  const languageLinks = document.querySelectorAll('.meta-navigation__list-link--language');

  languageLinks.forEach((languageLink) => {
    const languageMenu = languageLink.nextElementSibling;
    const closeButton = languageMenu.querySelector('.meta-navigation__language-close');

    function toggleLanguageMenu(event) {
      if (event) {
        event.preventDefault();
      }

      const isOpen = languageMenu.classList.contains('open');
      languageMenu.classList.toggle('open');
      languageLink.setAttribute('aria-expanded', !isOpen);
      languageMenu.setAttribute('aria-hidden', isOpen);
    }

    function closeLanguageMenu(event) {
      event.preventDefault();
      if (languageMenu.classList.contains('open')) {
        languageMenu.classList.remove('open');
        languageLink.setAttribute('aria-expanded', 'false');
        languageMenu.setAttribute('aria-hidden', 'true');
      }
    }

    languageLink.addEventListener('click', toggleLanguageMenu);
    closeButton.addEventListener('click', closeLanguageMenu);

    // Allow toggling using Enter key
    languageLink.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.keyCode === 13) {
        event.preventDefault();
        toggleLanguageMenu();
      }
    });

    closeButton.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.keyCode === 13) {
        event.preventDefault();
        closeLanguageMenu(event);
      }
    });
  });
});
